import { Component } from '../../../Models/Component';
import { ComponentsActionType, IReceiveComponentsAction, IRequestComponentsAction } from './Components.action-types';

export function requestComponents(): IRequestComponentsAction {
  return {
    type: ComponentsActionType.REQUEST_COMPONENTS,
  };
}

export function receiveComponents(components: Component[]): IReceiveComponentsAction {
  return {
    type: ComponentsActionType.RECEIVE_COMPONENTS,
    components,
  };
}
